import { Dialog as BaseDialog, Transition } from "@headlessui/react";
import { ReactNode, useRef } from "react";

import { useTheme } from "@/modules/theme/hooks/useTheme";

import { Typography } from "../Typography/Typography";

import { createDialogStyles } from "./helpers/createDialogStyles";

interface DialogProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  description?: string;
  children?: ReactNode;
}

export function Dialog({
  title,
  description,
  onClose,
  isOpen,
  children,
}: DialogProps) {
  const classes = createDialogStyles(useTheme());

  const dialogRef = useRef<null | HTMLDivElement>(null);

  return (
    <Transition show={isOpen}>
      <BaseDialog onClose={onClose} initialFocus={dialogRef}>
        <div aria-hidden="true" className={classes.overlay} />
        <div className={classes.dialog} ref={dialogRef}>
          <div className={classes.dialogHeaderWrapper}>
            {title && (
              <BaseDialog.Title as="div">
                <Typography variant="subheading" className={classes.title}>
                  {title}
                </Typography>
              </BaseDialog.Title>
            )}
            {description && (
              <BaseDialog.Description as="div">
                <Typography variant="contentMedium" className={classes.text}>
                  {description}
                </Typography>
              </BaseDialog.Description>
            )}
          </div>
          {children}
        </div>
      </BaseDialog>
    </Transition>
  );
}
